import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  tituloCampo: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    fontSize: theme.typography.h5.fontSinze,
  },
  heading: {
    marginRight: theme.spacing(2),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  menuAcao: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  pageTitle: {
    fontSize: theme.typography.h6.fontSinze,
  },
  item: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
  fieldDescricao: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  gridTitle: {
    borderBottom: 'thin solid #DDD',
  },
  titleCampo: {
    fontSize: theme.typography.h6.fontSize,
    marginTop: theme.spacing(3),
  },
}))

export default useStyles
